<p-dialog [modal]="true" [maximizable]="false" [closable]="false" styleClass="task-create-form body-p-dialog"
    [blockScroll]="false" [responsive]="true" [(visible)]="displayAddEditDialog" [style]="{width: '60vw'}"  [focusOnShow]="false" appendTo="body">
    <ng-template pTemplate="header">
        <div class="w-100">
            <div style="display: flex; justify-content: space-between; width: 100%;">
                <h5 class="p-mb-0">
                    {{ headerTitle }}
                </h5>
                <button pButton pRipple (click)="cancelNewTask()" class="p-button-text p-button-rounded p-pt-0" icon="pi pi-times"></button>
            </div>
            <div class="p-d-flex">
                <div class="p-field-radiobutton p-mb-0">
                    <p-radioButton name="task" value = 1 [(ngModel)]="taskType" [disabled]="taskEditId || isCopyTask" inputId="input1" (ngModelChange)="onTaskTypeChange()"></p-radioButton>
                    <label for="input1" tooltipPosition="bottom" pTooltip="Create single task for one or more than one users">Single Task</label>
                </div>
                <div class="p-field-radiobutton p-mb-0 p-ml-3">
                    <p-radioButton name="task" value = 2 [(ngModel)]="taskType" [disabled]="taskEditId || isCopyTask" inputId="input2" (ngModelChange)="onTaskTypeChange()"></p-radioButton>
                    <label for="input2" pTooltip="Create one or multiple tasks for one or more than one users" tooltipPosition="bottom" >Multiple Task</label>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-container *ngIf="taskType == TaskType.Individual || TaskType.Group">
        <form [formGroup]="taskDetailsForm">
            <div class="header p-d-flex p-ai-center">
                <h5 cla>Task Information</h5>
                <div class="p-d-flex p-ml-auto" *ngIf="taskEditId === 0">
                    <label for="switch1" class="p-mr-1">Restrict Email and Notifications for me</label>
                     <p-inputSwitch inputId="switch1"
                     formControlName="restrictNotifications"
                     (onChange)="onNotificationSwitchChange($event)"
                     />
                </div>

            </div>
            <div class="card">
                <div class="p-grid">
                    <div class="p-col-6 p-md-3">
                        <label for="startDate">Start Date & Time <span style="color: red;">*</span></label>
                        <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                            placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                              formControlName="startDateTime"
                            [showTime]="true" [hourFormat]="12" [disabled]="taskType == 2"></p-calendar>
                        <div *ngIf="detailsFormErrors?.startDateTime" class="p-invalid">
                            <small>{{ detailsFormErrors?.startDateTime }}</small>
                        </div>
                        <div *ngIf="taskDetailsForm.errors?.isStartDateLessThanEndDate" class="p-invalid">
                            <small>Start Date & Time must be earlier than Due Date & Time.</small>
                        </div>
                    </div>
                    <div class="p-col-6 p-md-3">
                        <label for="endDate" style="display:block">Due Date & Time <span style="color: red;">*</span></label>
                        <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                            placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" [disabled]="taskType == 2" yearRange="1900:2100"
                             formControlName="endDateTime"
                            showTime="true" [hourFormat]="12"></p-calendar>
                        <div *ngIf="detailsFormErrors?.endDateTime" class="p-invalid">
                            <small>{{ detailsFormErrors?.endDateTime }}</small>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <label for="taskCategory">Task Category <span style="color: red;">*</span></label>
                        <p-dropdown [options]="taskCategories" optionLabel="name" optionValue="id"
                            formControlName="taskCategoryId" aria-placeholder="Select Task Category" [resetFilterOnHide]="true" appendTo="body" [filter]="true">
                            <ng-template pTemplate="footer">
                                <button type="button" pButton (click)="addNewCategory()" icon="pi pi-plus"
                                    label="Add New Task Category" class="p-button-secondary footer-button"></button>
                            </ng-template></p-dropdown>
                        <div *ngIf="detailsFormErrors?.taskCategoryId" class="p-invalid">
                            <small>{{ detailsFormErrors?.taskCategoryId }}</small>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6" *ngIf="taskFeildData?.relatedTo">
                        <label for="relatedTo">Related To</label>
                        <p-dropdown [options]="taskModules" [disabled]="taskFromModule" optionLabel="name"
                            optionValue="id" formControlName="relatedTo"
                            (onChange)="onChangeModule($event.value,true)" appendTo="body"
                            [showClear]="true" placeholder="Select Module">
                        </p-dropdown>
                    </div>
                    <div class="p-col-12 p-md-6" *ngIf="taskDetailsForm.get('relatedTo').value">
                        <label for="channel">Channel</label>
                        <p-dropdown [options]="channelsN" optionLabel="name" [disabled]="taskFromModule"
                            optionValue="id"
                            (onChange)="onChangeChannel($event.value,true)"
                            formControlName="channelId" [showClear]="true" [filter]="true" [resetFilterOnHide]="true" appendTo="body" placeholder="Select Channel">
                        </p-dropdown>
                    </div>
                    <div class="p-col-12 p-md-6" *ngIf="taskType == TaskType.Individual">
                        <label for="assigned">{{taskEditDetails?.task?.taskUsers[0]?.reAssignedUserId ? 'Re-Assign To' : 'Assign To'}} <span style="color: red;">*</span><span style=" color: var(--primary-color);"> <i
                                    *ngIf="taskDetailsForm.get('assignedTo').value" (click)="assignUser()" class="pi pi-user-edit p-ml-1"
                                    pTooltip="Edit" tooltipPosition="right"></i></span></label>
                        <div class="association-container">
                            <span (click)="assignUser()" *ngIf="!taskDetailsForm.get('assignedTo').value" class="hyper-link"><strong
                                    class="association-name"><i class="pi pi-plus p-mr-2"></i> Select Users</strong></span>
                            <ng-container
                                *ngIf="taskDetailsForm.get('assignedTo').value && taskDetailsForm.get('assignedTo').value.length > 0">
                                <ng-container *ngFor="let user of taskDetailsForm.get('assignedTo').value">
                                    <p-chip styleClass="p-mr-2 custom-chip" label="{{ user?.name }}" [removable]="true"
                                        (onRemove)="removeAssignTo(user)">
                                    </p-chip>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div *ngIf="detailsFormErrors?.assignedTo" class="p-invalid">
                            <small>{{ detailsFormErrors?.assignedTo }}</small>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6" *ngIf="taskDetailsForm.get('relatedTo').value">
                        <label for="association">Association <span> <i style=" color: var(--primary-color);"  pTooltip="Edit" tooltipPosition="right" *ngIf="[1,2].includes(taskDetailsForm.get('relatedTo').value) && taskDetailsForm.get('association').value && !taskFromModule" (click)="assignData()" class="pi pi-pencil"></i></span></label>
                        <ng-container *ngIf="[1,2].includes(taskDetailsForm.get('relatedTo').value)">
                            <div class="association-container">
                                <span (click)="assignData()" *ngIf="!taskDetailsForm.get('association').value" class="hyper-link"><strong
                                        class="association-name"><i class="pi pi-plus p-mr-2"></i> Select Association</strong></span>
                                <ng-container *ngIf="taskDetailsForm.get('association').value && taskDetailsForm.get('association').value.length > 0">
                                    <ng-container *ngFor="let association of taskDetailsForm.get('association').value">
                                        <p-chip styleClass="p-mr-2 custom-chip"  label="{{ association?.businessName }}" [removable]="!taskFromModule" (onRemove)="reseAssociation(association)">
                                        </p-chip>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="![1,2].includes(taskDetailsForm.get('relatedTo').value)">
                            <p-multiSelect [autoDisplayFirst]="false" [disabled]="taskFromModule" [options]="associationNames"
                                name="association" placeholder="Select Association" optionLabel="businessName"
                                (onFilter)="getAssociationNames($event.filter)" id="association" appendTo="body"
                                formControlName="association" dataKey="id" filter="true" [showClear]="true"
                                [panelStyle]="{'max-width':'500px'}" panelStyleClass="word-break"
                                emptyFilterMessage="No association name is found for this user.">
                            </p-multiSelect>
                        </ng-container>
                    </div>
                    <ng-container>
                        <div class="p-col-12 p-md-6" *ngIf="taskFeildData?.sharedWithMe">
                            <label for="shareTaskWith">Share task with </label>
                            <p-multiSelect [options]="sharedTaskWith" optionLabel="name" optionValue="id"
                                placeholder="Select Users" appendTo="body" formControlName="sharedUsers" [resetFilterOnHide]="true"
                                [ngClass]="{ 'ng-invalid': showValidation && (!selectedUsers || selectedUsers.length==0) }">
                                <ng-template let-user pTemplate="item">
                                    <div class="user-item" [ngClass]="{'inactive-item': user.statusId == 2 }">
                                        <div>{{user.name}}</div>
                                    </div>
                                </ng-template>
                            </p-multiSelect>
                        </div>
                    </ng-container>
                    <div class="p-col-12" *ngIf="taskFeildData?.taskTitle">
                        <label for="taskTitle">Task Title</label>
                        <input pInputText type="text" formControlName="taskTitle" />
                    </div>
                </div>
                <div class="p-grid" *ngIf="taskType == TaskType.Individual">
                    <div class="p-col-12">
                        <label for="taskDetails">Task Details<span style="color: red;">*</span></label>
                        <p-editor #editorText [style]="{'height':'100px'}" formControlName="taskDetails">
                            <p-header>
                                <span class="ql-formats">
                                    <select class="ql-size">
                                        <option value="small">small</option>
                                        <option selected></option>
                                        <option value="large">large</option>
                                        <option value="huge">huge</option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <select class="ql-size">
                                        <option value="24px">24</option>
                                        <option value="48px">48</option>
                                        <option value="100px">100</option>
                                        <option value="200px">200</option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-bold" aria-label="Bold"></button>
                                    <button class="ql-italic" aria-label="Italic"></button>
                                    <button class="ql-underline" aria-label="Underline"></button>
                                    <button class="ql-strike" aria-label="Strike"></button>
                                </span>
                                <span class="ql-formats">
                                    <select title="Text Color" class="ql-color"></select>
                                    <span class="ql-format-separator"></span>
                                    <select title="Background Color" class="ql-background"></select>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-list" value="ordered"></button>
                                    <button class="ql-list" value="bullet"></button>
                                    <select title="Text Alignment" class="ql-align">
                                        <option selected>Gauche</option>
                                        <option value="center" label="Center"></option>
                                        <option value="right" label="Right"></option>
                                        <option value="justify" label="Justify"></option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <button aria-label="Link" class="ql-link"></button>
                                </span>
                            </p-header>
                        </p-editor>
                        <div *ngIf="detailsFormErrors?.taskDetails" class="p-invalid">
                            <small>{{ detailsFormErrors?.taskDetails }}</small>
                        </div>
                    </div>
                </div>
                <!-- #region GroupTask Section -->
                <div class="p-grid" *ngIf="taskType == TaskType.Group">
                    <div class="p-col-12">
                        <div class="p-d-flex p-jc-between">
                            <div class="p-d-flex">
                                <label for="taskList" class="p-mt-2">Task List: </label>
                                <div class="p-field-checkbox p-mb-0 p-ml-3">
                                    <p-checkbox [binary]="true" [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="taskOrder" inputId="binary"></p-checkbox>
                                    <label for="binary">Task Order</label>
                                </div>
                            </div>
                            <p-button icon="pi pi-plus"  pTooltip="Add Task"
                            tooltipPosition="top" (onClick)="addTaskMulti()"></p-button>
                        </div>
                        <ul style="margin-left: -38px;" cdkDropList [cdkDropListData]="groupAllTaskList"
                            (cdkDropListDropped)="drop($event)">
                            <div *ngFor="let task of groupAllTaskList;let i=index;" cdkDrag>
                                <div class="p-d-flex task-box colList">
                                    <div style="min-width: 20px;">{{ i + 1 }}<strong>.</strong></div>
                                    <div style="flex-grow: 1;">
                                        <div class="task-header p-d-flex p-jc-between p-pl-2 p-pr-2 p-pt-2 p-pb-0">
                                            <div class="p-d-flex">
                                                <div><strong> {{task?.assignTo?.name}}</strong> </div>
                                                <!-- <div class="p-ml-3 p-mt-1 task-time">Last Updated Time:</div> -->
                                            </div>
                                            <div class="p-d-flex">
                                                <div class="task-time p-mt-1"><strong> Start Date:</strong></div>
                                                <div class="p-mr-2 task-time p-mt-1"><strong>{{task.startDate | date: 'MM/dd/yyyy, h:mm a'}}</strong></div>
                                                <div class="task-time p-mt-1"><strong> Due Date:</strong> </div>
                                                <div class="task-time p-mt-1"><strong> {{task.endDate | date: 'MM/dd/yyyy, h:mm a'}}</strong> </div>
                                                <span class="btnBars p-ml-2" (click)="editTaskMulti(i)" pTooltip="Edit"
                                                    tooltipPosition="top" *ngIf="groupAllTaskList?.length>0">
                                                    <i class="pi pi-pencil"></i>
                                                </span>
                                                <span class="btnBars p-ml-2" (click)="deleteTask(i)" pTooltip="Delete"
                                                tooltipPosition="top">
                                                <i class="pi pi-trash"></i>
                                            </span>
                                            </div>
                                        </div>
                                        <div class="p-p-2 task-content" [innerHTML]="getSanitizedTaskDescription(task?.description)"></div>
                                    </div>
                                </div>
                                <p-divider styleClass="custom-divider" type="dashed"></p-divider>
                            </div>
                        </ul>
                    </div>
                </div>
                <div *ngIf="taskType == TaskType.Individual" class="p-grid" formArrayName="checklist">
                </div>

                <div class="p-grid">
                    <div class="p-col-6">
                        <label for="upload">Attachments(Max Size 2MB)  <i class="pi pi-exclamation-circle" [escape]="false"
                            [pTooltip]="multiLineTooltip" tooltipPosition="top"></i></label>
                        <p-fileUpload (onSelect)="uploadAttachments($event.files)" [showUploadButton]="false"
                            customUpload="true" [showCancelButton]="false" [multiple]="true">
                            <ng-template pTemplate="file"></ng-template>
                            <ng-template pTemplate="content">
                                <ng-container *ngFor="let file of uploadedFiles; let i = index;">
                                    <div class="p-fileupload-row p-mb-2">
                                        <button pButton icon="fa fa-download" (click)="downloadFile(file.name,
                                                    file.content,file.location)" class="p-button-link p-px-0 p-py-0">
                                        </button>
                                        <div>
                                            {{ file.name }}
                                        </div>
                                        <div>
                                            {{ file.sizeInBytes | fileSize }}
                                        </div>

                                            <button icon="pi pi-times" pButton (click)="removeAttachment(file)"
                                                type="button" class="p-mr-1 p-mt-1">
                                            </button>

                                    </div>
                                </ng-container>
                            </ng-template>
                        </p-fileUpload>
                    </div>
                </div>
                <div class="p-text-right">
                    <button type="button" style="margin: 10px 0;" pButton (click)="showAddMore= !showAddMore"
                        label="{{showAddMore ? 'Show Less' : 'Show More'}}" class="p-button-secondary"></button>
                </div>
                <div class="p-grid" *ngIf="showAddMore">
                    <div class="p-col-12 p-md-6">
                        <label for="reminderType">Reminder Type</label>
                        <p-dropdown [options]="reminderTypes" optionLabel="name" optionValue="id" appendTo="body"
                            formControlName="reminderTypeId" placeholder="Selected Reminder Type" [disabled]="taskEditId"></p-dropdown>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <label for="reminder">Reminder</label>
                        <p-dropdown [options]="reminderDelay" optionLabel="name" appendTo="body"
                            formControlName="reminderDelay" placeholder="Selected Reminder" optionValue="value" [disabled]="taskEditId"></p-dropdown>
                    </div>
                </div>
                <div class="p-grid" *ngIf="showAddMore">
                    <div class="p-col-12 p-md-6">
                        <label for="taskRepeat">Task Repeat</label>
                        <div class="p-d-flex">
                            <div [ngStyle]="{'width': '100%'}">
                                <p-dropdown [options]="repeat" optionLabel="name" appendTo="body" optionValue="id"
                                    formControlName="taskRepeat" placeholder="Selected Repeat" [disabled]="taskEditId"></p-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <label for="priority">Priority</label>
                        <p-dropdown [options]="priority" optionLabel="name" optionValue="id" appendTo="body"
                            formControlName="priorityId" placeholder="Selected Priority" [disabled]="taskEditId">
                        </p-dropdown>
                    </div>
                </div>
            </div>
        </form>
    </ng-container>
    <ng-template pTemplate="footer">
        <button pButton (click)="cancelNewTask()" label="Cancel" class="p-button-secondary"></button>
        <button pButton (click)="onSaveTask()" label="Save"></button>
    </ng-template>
</p-dialog>

<p-dialog [header]="checklistHeader" [modal]="true" [maximizable]="false" [responsive]="true"
    [(visible)]="displayAddEditList" [style]="{width: '50vw'}">
    <form [formGroup]="checkListForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <label for="listItem">List Item</label>
                    <input type="text" pInputText formControlName="description">
                </div>
            </div>
            <div class="p-grid" *ngIf="taskEditId > 0">
                <div class="p-col-12">
                    <label for="markCompleted">Mark Completed</label>
                    <div class="p-field-checkbox p-mb-0">
                        <p-checkbox formControlName="isMarkedCompleted" [binary]="true" inputId="binary"></p-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="displayAddEditList=false;" label="Cancel" class="p-button-secondary"></button>
        <button pButton (click)="saveList()" label="Save"></button>
    </ng-template>
</p-dialog>

<p-dialog *ngIf="displayAddTaskCategory" header="Add New Task Category" [modal]="true" [responsive]="true"
    [(visible)]="displayAddTaskCategory" [style]="{width: '50vw'}" appendTo="body">
    <form [formGroup]="addTaskCategoryForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <label for="categoryName">Name <span style="color: red;">*</span></label>
                    <input  formControlName="categoryName" type="text" pInputText>
                    <div *ngIf="detailsFormErrors?.categoryName" class="p-invalid">
                        <small>{{ detailsFormErrors?.categoryName }}</small>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="cancelNewTaskCategory()" label="Cancel" class="p-button-secondary"></button>
        <button pButton [loading]="isLoadingInputNewTaskCategoryName" (click)="saveNewTaskCategory()"
            label="Save"></button>
    </ng-template>
</p-dialog>


<p-dialog [header]="checklistHeader2" [modal]="true" [maximizable]="false" [responsive]="true"
    [(visible)]="displayGroupTaskList" [style]="{width: '50vw'}" [focusOnShow]="false" appendTo="body">
    <form [formGroup]="groupTaskDetailsForm">
        <div class="card">
            <div class="task-box">
                <div class="task-header p-d-flex p-jc-between">
                    <div class="p-col-12 p-md-6">
                        <label for="assigned">  {{ groupTaskDetailsForm?.get('reAssignedStatus')?.value === true  ? 'Re-Assign To' : 'Assign To' }}<span style="color: red;">*</span>
                            <span style="color: var(--primary-color);">
                                <i *ngIf="groupTaskDetailsForm.get('assignTo')?.value" (click)="assignUser()" class="pi pi-user-edit p-ml-1" pTooltip="Edit" tooltipPosition="right"></i>
                            </span>
                        </label>
                        <div class="association-container">
                            <span (click)="assignUser()" *ngIf="!groupTaskDetailsForm.get('assignTo')?.value" class="hyper-link">
                                <strong class="association-name"><i class="pi pi-plus p-mr-2"></i> Select Users</strong>
                            </span>
                            <ng-container *ngIf="groupTaskDetailsForm.get('assignTo')?.value">
                                <ng-container *ngIf="groupTaskDetailsForm.get('assignTo').value">
                                    <p-chip styleClass="p-mr-2 custom-chip" label="{{ groupTaskDetailsForm.get('assignTo')?.value?.name }}" [removable]="false">
                                    </p-chip>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div *ngIf="detailsFormErrors?.assignTo" class="p-invalid">
                            <small>{{ detailsFormErrors?.assignTo }}</small>
                        </div>
                    </div>

                    <div class="p-d-flex">
                        <div></div>
                        <span class="p-mt-2" style="font-size: 10px;">Start Date:</span>
                        <p-calendar formControlName="startDate" showTime="true" appendTo="body" styleClass="task-calendar"
                        [monthNavigator]="true"   [yearNavigator]="true"  inputId="icon" [hourFormat]="12"  placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"></p-calendar>
                        <span class="p-mt-2" style="font-size: 10px;">Due Date:</span>
                        <p-calendar appendTo="body" showTime="true" formControlName="endDate" styleClass="task-calendar"
                        [monthNavigator]="true"   [yearNavigator]="true"  inputId="icon" [hourFormat]="12"  placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"></p-calendar>
                    </div>
                </div>
                <div>
                    <p-editor #editor [style]="{'height':'100px'}" formControlName="description">
                        <p-header>
                            <span class="ql-formats">
                                <select class="ql-size">
                                    <option value="small">small</option>
                                    <option selected></option>
                                    <option value="large">large</option>
                                    <option value="huge">huge</option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <select class="ql-size">
                                    <option value="24px">24</option>
                                    <option value="48px">48</option>
                                    <option value="100px">100</option>
                                    <option value="200px">200</option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-bold" aria-label="Bold"></button>
                                <button class="ql-italic" aria-label="Italic"></button>
                                <button class="ql-underline" aria-label="Underline"></button>
                                <button class="ql-strike" aria-label="Strike"></button>
                            </span>
                            <span class="ql-formats">
                                <select title="Text Color" class="ql-color"></select>
                                <span class="ql-format-separator"></span>
                                <select title="Background Color" class="ql-background"></select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-list" value="ordered"></button>
                                <button class="ql-list" value="bullet"></button>
                                <select title="Text Alignment" class="ql-align">
                                    <option selected>Gauche</option>
                                    <option value="center" label="Center"></option>
                                    <option value="right" label="Right"></option>
                                    <option value="justify" label="Justify"></option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <button aria-label="Link" class="ql-link"></button>
                            </span>
                        </p-header>
                    </p-editor>
                    <div *ngIf="detailsFormErrors?.description" class="p-invalid">
                        <small>{{ detailsFormErrors?.description}}</small>
                    </div>
                </div>

            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="displayGroupTaskList=false;" label="Cancel" class="p-button-secondary"></button>
        <button pButton (click)="saveGroupTaskList()" label="Save"></button>
    </ng-template>
</p-dialog>

<app-shared-manual-modal [displayPopup]="displayManualPopup" [showActiveInActive]="true"
    [colsList]="manualRuleColumnSetttings"  [selectedObjectType]="selectedModule"
    [selectedTemplateType]="selectedChannel" [selectedAccount]="selectedRecordList"
    (saveAssignDataclicked)="saveAssignData($event)" (cancelClicked)="manualpopupCancelClicked()"
    (saveSettingClicked)="columnSettingSaved($event)">
</app-shared-manual-modal>

<!-- Assign-To-User pop-up -->
<app-assign-users [displayUsersPopup]="displayUsers"
    [selectedUsersList]="selectedReassignUser"
    [singleSelection]="isAssignToSingleOrMulti"
    (saveAssignDataclicked)="saveAssignUser($event)"
    (cancelClicked)="assignUserPopupCancelClicked()">
</app-assign-users>

<p-toast position="top-right" [baseZIndex]="10000"></p-toast>
<p-confirmDialog [style]="{width: '20vw'}" key="confirmTask" [baseZIndex]="1000000"></p-confirmDialog>
